module.exports = __webpack_public_path__ + "img/img04.d3a4cfd3.png";